export const sidebarTransition = 'all 0.4s ease-in-out';
